import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const Container = ({ children, className }: Props): ReactElement => {
  return (
    <div
      className={twMerge(
        `
      w-full
      2xl:container
      mx-auto
      px-2
      sm:px-4
      `,
        className
      )}
    >
      {children}
    </div>
  );
};

export default Container;
